// eslint ignore
import React, {useState} from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import OutlinedInput from "@mui/material/OutlinedInput";
import {NumberInput} from '@process-advisor/process-miner/discovery/numberInput'
import * as _ from 'lodash/fp';
import { FormControl, MenuItem, Select as MaterialSelect,  } from '@mui/material';
import { getColor, getFontSize, getShadow } from '@process-advisor/process-miner/shared/theme';
import Typography from '@mui/material/Typography';
import { SingleBlock } from '@process-advisor/process-miner/slicers/singleBlock';
import { Button as ApplyButton } from '@process-advisor/process-miner/components/shared/button';
import { AlertMessage } from '@process-advisor/process-miner/components/alerts/alert';
import { Section } from '@process-advisor/process-miner/components/shared/section';
import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

const RowWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

const ApplyWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 5px;
`;

const HeaderGrid = styled.div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: 60px 135px 150px 70px ;
  padding-bottom: 5px;
`;

const LogicLabel = styled.div`
    grid-row: 1 / 1 ;
    grid-column: 1 / 6 ;
`;

const FilterLabel = styled.div`
    grid-row: 1 / 1 ;
    grid-column: 2 / 6 ;
`;

const OperatorLabel = styled.div`
    grid-row: 1 / 1 ;
    grid-column: 3 / 6 ;
`;

const FromLabel = styled.div`
    grid-row: 1 / 1 ;
    grid-column: 4 / 6 ;
`;

const FilterWrapper = styled.div`
    margin: 0px 5px 5px 0px; 
    height: 35px;
`;

const OperatorWrapper = styled.div`
    margin: 0px 5px 5px 5px; 
    height: 35px;
`;

const RelativeWrapper = styled.div`
    margin: 0px 5px 5px 5px; 
    height: 35px;
`;

const TimeWrapper = styled.div`
    margin: 0px 5px 5px 5px; 
    height: 35px;
`;

const ConditionWrapper1 = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0px 5px 5px 5px; 
    height: 35px;
`;

const ConditionWrapper2 = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0px 5px 5px 5px; 
    height: 35px;
`;

const OrButtonContainer = styled(Button)`
    margin: 0px 5px 5px 5px; 
    height: 35px;
`;

const AndButtonContainer = styled(Button)`
    margin: 0px 5px 5px 5px; 
    height: 35px;
`;

const RemoveButtonContainer = styled(Button)`
    margin: 0px 5px 5px 5px; 
    height: 35px;
`;

const LogicContainerLeft = styled(Button)`
    padding-top: 3px;
    width: 60px;
    justify-content: left
`;

const LogicContainerRight = styled(Button)`
    padding-top: 3px;
    width: 100px;
    justify-content: right
`;


const Select = styled(MaterialSelect)`
    border-color: ${getColor('lightBorderColor')};
    border-radius: 8px;
    color: ${getColor('inputTextColor')};
    font-size: ${getFontSize('smaller')};
    margin-right: 10px;
    padding: 5px 5px;
    height: 35px;
    width: 100%;

    .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
        padding: 3px 3px;
    }

    & .MuiMenu-paper {
        border-radius: 10px;
        margin-top: 10px;
        box-shadow: ${getShadow('menu')};
        border: .5px solid ${getColor('borderColor')};
    }

    & .MuiMenuItem-root {
        font-size: ${getFontSize('smaller')};
        color: ${getColor('darkFontColor')};
        padding: 3px 5px;
        display: flex;
        justify-content: space-between;
    }

    & .Mui-selected img {
        display: block;
    }

    & legend {
        width: 0 !important;
        border-bottom: none !important;
    }
`;

const operators = [
    { value: 'greater than', label: 'Greater than' },
    { value: 'greater than or is', label: 'Greater than or is' },
    { value: 'less than', label: 'Less than' },
    { value: 'less than or is', label: 'Less than or is' },
    { value: 'equal to', label: 'Equal to' },
    { value: 'not equal to', label: 'Not equal to' },
    { value: 'between', label: 'Between' },
    { value: 'between or is', label: 'Between or is' },
    { value: 'outside', label: 'Outside' },
    { value: 'outside or is', label: 'Outside or is' },
];

const relativeOperators = [
    { value: 'longest duration percentile', label: 'Longest duration percentile' },
    { value: 'shortest duration percentile', label: 'Shortest duration percentile' },
    { value: 'longest std deviation percentile', label: 'Longest std deviation percentile' },
    { value: 'shortest std deviation percentile', label: 'Shortest std deviation percentile' },
];

const times = [
    { value: 'secs', label: 'secs' },
    { value: 'mins', label: 'mins' },
    { value: 'hrs', label: 'hrs' },
    { value: 'days', label: 'days' },
];

const variantFilters = (entityLabelPlural) => [
    { value: entityLabelPlural, label: entityLabelPlural },
    { value: 'Avg Duration', label: 'Avg Duration' },
    { value: 'Min Duration', label: 'Min Duration' },
    { value: 'Max Duration', label: 'Max Duration' },
    { value: 'Std Deviation', label: 'Std Deviation' },
    { value: 'Activities', label: 'Activities' },
    { value: 'Steps', label: 'Steps' },
    { value: 'Loops', label: 'Loops' },
    { value: 'Relative', label: 'Percentiles' },
];

const stepFilters = (entityLabelPlural) => [
    { value: entityLabelPlural, label: entityLabelPlural },
    { value: 'Avg Duration', label: 'Avg Duration' },
    { value: 'Std Deviation', label: 'Std Deviation' },
    { value: 'avg_customer_comments', label: 'Avg Customer Comments' },
    { value: 'avg_internal_comments', label: 'Avg Internal Comments' },
    { value: 'avg_timespent', label: 'Avg Time Spent' },
    { value: 'Relative', label: 'Percentiles' },
];

const activityFilters = (entityLabelPlural) => [
    { value: entityLabelPlural, label: entityLabelPlural },
    { value: 'Avg Duration', label: 'Avg Duration' },
    { value: 'Std Deviation', label: 'Std Deviation' },
    { value: 'Relative', label: 'Percentiles' },
];

export const Discovery = ({type}) => {
    const entityLabelPlural = apiProvider.getEntityUpper() + 's';
    const defaultData = [];
    defaultData.push({
        id: 0,
        type: 'Variants',
        logic: '',
        filter: entityLabelPlural,
        operator: 'greater than',
        relative: 'longest duration percentile',
        from: '',
        to: '',
        time: 'hrs'
        });

    const [routesData, setRoutesData] = React.useState(defaultData);
    const [applyEnabled,setApplyEnabled] = React.useState(true);
    const [metricType, setMetricType] = React.useState('Variants');
    const [filters, setFilters] = React.useState(variantFilters(entityLabelPlural));
    const sleep = ms => new Promise(r => setTimeout(r, ms));

    React.useEffect(() => {
        setMetricType(type)
        if (type === 'Variants') setFilters(variantFilters(entityLabelPlural))
        if (type === 'Steps') setFilters(stepFilters(entityLabelPlural))
        if (type === 'Activities') setFilters(activityFilters(entityLabelPlural))
    }, [type]);
    
    const handleAddRouteOr = (id) => {
        const index = routesData.findIndex((item) => item.id === id);
        const newData = [...routesData];
        newData.push({
            id: index + 1,
            type: type,
            logic: 'or',
            filter: '',
            operator: '',
            relative: '',
            from: '',
            to: '',
            time: ''
        });
        setRoutesData(newData);
        checkApply(newData)
    };

    const handleAddRouteAnd = (id) => {
        const index = routesData.findIndex((item) => item.id === id);
        const newData = [...routesData];
        newData.push({
            id: index + 1,
            type: type,
            logic: 'and',
            filter: entityLabelPlural,
            operator: 'greater than',
            relative: 'longest duration percentile',
            from: '',
            to: '',
            time: 'hrs'
        });
        setRoutesData(newData);
        checkApply(newData)
    };

    const handleRemoveRoute = (id) => {
        const itemIndex = routesData.findIndex((item) => item.id === id);
        const newData = [...routesData];
        newData.splice(itemIndex,1)
        setRoutesData(newData);
        checkApply(newData)
    };

    const handleFilterChange = (itemId,  payload) => {
        const index = routesData.findIndex((item) => item.id === itemId);
        const newData = [...routesData];
        newData[index].filter = payload.filter.target.value
        setRoutesData(newData);
        checkApply(newData)
    }

    const FilterSelect = ({itemId,onChange,name}) => {
        if (itemId > routesData.length) itemId = routesData.length -1
        const handleChange = (value) => {onChange(itemId, {[name]: value});};
        return (
            <FilterWrapper>
                <FormControl sx={{ width: 120}}>
                    <Select value={routesData[itemId].filter} defaultValue={entityLabelPlural} label="Field" sx={{ fontSize: 14 }} onChange={handleChange} input={<OutlinedInput />}>
                        {
                            _.map(({ value: optionValue, label }) => (
                                <MenuItem key={optionValue} sx={{ fontSize: 12 }} value={optionValue}>
                                    {label}
                                </MenuItem>
                            ))(filters)
                        }
                    </Select>
                </FormControl>            
            </FilterWrapper>
        );
    }

    const handleOperatorChange = (itemId,  payload) => {
        const index = routesData.findIndex((item) => item.id === itemId);
        const newData = [...routesData];
        newData[index].operator = payload.operator.target.value
        setRoutesData(newData);
        checkApply(newData)
    }

    const OperatorSelect = ({itemId,onChange,name}) => {
        const handleChange = (value) => {onChange(itemId, {[name]: value});};
        return (
            <OperatorWrapper>
                <FormControl sx={{ width: 140 }}>
                    <Select value={routesData[itemId].operator} label="Operator" sx={{ fontSize: 14 }} onChange={handleChange} input={<OutlinedInput />}>
                        {
                            _.map(({ value: optionValue, label }) => (
                                <MenuItem key={optionValue} sx={{ fontSize: 12 }} value={optionValue}>
                                    {label}
                                </MenuItem>
                            ))(operators)
                        }
                    </Select>
                </FormControl>            
            </OperatorWrapper>
            
        );
    }

    const handleRelativeOperatorChange = (itemId,  payload) => {
        const index = routesData.findIndex((item) => item.id === itemId);
        const newData = [...routesData];
        newData[index].relative = payload.relative.target.value
        setRoutesData(newData);
        checkApply(newData)
    }
   
    const RelativeSelect = ({itemId,onChange,name}) => {
        const handleChange = (value) => {onChange(itemId, {[name]: value});} ;
        return (
            <RelativeWrapper>
                <FormControl sx={{ width: 230 }}>
                    <Select value={routesData[itemId].relative} label="Relative" sx={{ fontSize: 14 }} onChange={handleChange} input={<OutlinedInput />}>
                        {
                            _.map(({ value: optionValue, label }) => (
                                <MenuItem key={optionValue} sx={{ fontSize: 12 }} value={optionValue}>
                                    {label}
                                </MenuItem>
                            ))(relativeOperators)
                        }
                    </Select>
                </FormControl>            
            </RelativeWrapper>
            
        );
    }

    const handleTimeChange = (itemId,  payload) => {
        const index = routesData.findIndex((item) => item.id === itemId);
        const newData = [...routesData];
        newData[index].time = payload.time.target.value
        setRoutesData(newData);
        checkApply(newData)
    }

    const handleActualFromChange = (itemId,  value) => {
        const index = routesData.findIndex((item) => item.id === itemId);
        const newData = [...routesData];
        newData[index].from = value
        setRoutesData(newData);
        checkApply(newData)
    }

    const handleActualToChange = (itemId,  value) => {
        const index = routesData.findIndex((item) => item.id === itemId);
        const newData = [...routesData];
        newData[index].to = value
        setRoutesData(newData);
        checkApply(newData)
    }

    const TimeSelect = ({itemId,onChange,name}) => {
        const handleChange = (value) => {onChange(itemId, {[name]: value});};
        return (
            <TimeWrapper>
                <FormControl sx={{ width: 80 }}>
                    <Select value={routesData[itemId].time} label="Time" sx={{ fontSize: 14 }} onChange={handleChange} input={<OutlinedInput />}>
                        {
                            _.map(({ value: optionValue, label }) => (
                                <MenuItem key={optionValue} sx={{ fontSize: 12 }} value={optionValue}>
                                    {label}
                                </MenuItem>
                            ))(times)
                        }
                    </Select>
                </FormControl>            
            </TimeWrapper>
            
        );
    }

    function checkApply(newData) {
        let applyOK = true
        for (let i = 0; i < routesData.length; i++) {
            routesData[i].type = type
        }
        for (let i = 0; i < newData.length; i++) {
            if (newData[i].filter === '') applyOK = false
            if (newData[i].operator === '') applyOK = false
            if (newData[i].filter === 'Relative' && newData[i].relative === '') applyOK = false
            if (newData[i].filter !== entityLabelPlural && newData[i].filter !== 'Steps' && newData[i].filter !== 'Loops') if (newData[i].time === '') applyOK = false
        }
        setApplyEnabled(!applyOK)
    }

    async function onApply () {
        await openProgressModal({status: 'Processing Discovery'})
        await sleep(50)
        await apiProvider.applyDiscovery({routesData: [...routesData]})
        setApplyEnabled(true)
        closeProgressModal()
    };
    
    return (
    <div>
        <HeaderGrid>
            <LogicLabel/>
            <FilterLabel>
                <Section title='Filter'/>
            </FilterLabel>
            <OperatorLabel>
                <Section title='Operator'/>
            </OperatorLabel>
        </HeaderGrid>      
        {routesData.map((item) => {
      
            return (
                <Wrapper key={item.id} >
                        {item.id == 0 ? <LogicContainerLeft/> : '' }
                        {item.id > 0  && item.logic === 'and' ? 
                            <LogicContainerLeft>
                                <Typography
                                    align="center"
                                    sx={{ fontSize: '14px', fontFamily: 'system-ui'
, color: '#0B66E4'}}
                                    component="div">
                                    and
                                </Typography>   
                            </LogicContainerLeft>  
                        : '' }
                        {item.id > 0  && item.logic === 'or' ? 
                            <LogicContainerRight>
                                <Typography
                                    align="center"
                                    sx={{ fontSize: '14px',  fontFamily: 'system-ui'
, color: '#0B66E4'}}
                                    component="div">
                                    or
                            </Typography>    
                            </LogicContainerRight> 
                         : ''}
                        <FilterSelect itemId={item.id} onChange={handleFilterChange} name='filter'/>

                        {item.filter != 'Relative' ?
                        <RowWrapper>
                            <OperatorSelect itemId={item.id} onChange={handleOperatorChange} name='operator'/>

                            { item.operator === 'greater than' || 
                            item.operator === 'greater than or is' ||
                            item.operator === 'less than' ||
                            item.operator === 'less than or is' ||
                            item.operator === 'equal to' ||     
                            item.operator === 'not equal to' ?     
                            <ConditionWrapper1>
                                <NumberInput itemId={item.id} label='' min={0} onChange={handleActualFromChange}/>
                                {item.filter === 'Avg Duration' || item.filter === 'Std Deviation' || item.filter === 'Min Duration' || item.filter === 'Max Duration' ?
                                    <TimeSelect itemId={item.id} onChange={handleTimeChange} name='time'/>
                                : ''}
                            </ConditionWrapper1>
                            : '' }
                            
                            { item.operator === 'between' || 
                            item.operator === 'between or is' ||
                            item.operator === 'outside' ||
                            item.operator === 'outside or is' ?     
                            <ConditionWrapper2>
                                <NumberInput label='' itemId={item.id} min={0} onChange={handleActualFromChange}/>
                                <NumberInput label='' itemId={item.id} min={0} onChange={handleActualToChange}/>
                                {item.filter === 'Avg Duration' || item.filter === 'Std Deviation' || item.filter === 'Min Duration' || item.filter === 'Max Duration'  ?
                                    <TimeSelect itemId={item.id} onChange={handleTimeChange} name='time'/>
                                : ''}
                            </ConditionWrapper2>
                            : '' }
                        </RowWrapper>
                        :
                        <RowWrapper>
                            <RelativeSelect itemId={item.id} onChange={handleRelativeOperatorChange} name='relative'/>
                            { item.relative === 'longest duration percentile' || item.relative === 'shortest duration percentile' || item.relative === 'longest std deviation percentile' || item.relative === 'shortest std deviation percentile'?
                            <ConditionWrapper1>
                                <NumberInput itemId={item.id} label='' min={0} onChange={handleActualFromChange}/>
                            </ConditionWrapper1>
                            : '' }
                        </RowWrapper>
                        }

                        <OrButtonContainer size="small" appearance="default" onClick={() => handleAddRouteOr(item.id)}>or</OrButtonContainer>
                        <AndButtonContainer size="small" appearance="default" onClick={() => handleAddRouteAnd(item.id)}>and</AndButtonContainer>
                        {item.id != 0  ?
                            <RemoveButtonContainer size="small" appearance="subtle" onClick={() => handleRemoveRoute(item.id)}>X</RemoveButtonContainer>
                        : '' }    
        
                </Wrapper>
            );
        })}
        <ApplyWrapper>
            <SingleBlock width="40%"/>
            <SingleBlock width="20%">
                <ApplyButton label='Apply' onClick={onApply} disabled={applyEnabled}/>
            </SingleBlock>
            <SingleBlock width="40%"/>
        </ApplyWrapper>
        <AlertMessage/>

    </div>
  );
};

